import { render, staticRenderFns } from "./viewChargeDialog.vue?vue&type=template&id=0cead50b"
import script from "./viewChargeDialog.vue?vue&type=script&lang=js"
export * from "./viewChargeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cead50b')) {
      api.createRecord('0cead50b', component.options)
    } else {
      api.reload('0cead50b', component.options)
    }
    module.hot.accept("./viewChargeDialog.vue?vue&type=template&id=0cead50b", function () {
      api.rerender('0cead50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/additionalCharge/components/viewChargeDialog.vue"
export default component.exports